import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatStepperModule } from '@angular/material/stepper';
import {MatDialogModule} from '@angular/material/dialog';
// import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
//import { MaterialModule } from '@angular/material';
// import { FormsModule }   from '@angular/forms';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatCardModule} from '@angular/material/card';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';


import { AppComponent } from './app.component';
import { LandingComponent } from './pages/landing/landing.component';
import { AppRoutingModule } from './/app-routing.module';
import { LoginComponent } from './pages/login/login.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NavigatorComponent } from './common/navigator/navigator.component';
import { FooterComponent } from './common/footer/footer.component';
import { BusinessComponent } from './pages/business/business.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MatSelectModule} from '@angular/material/select';
import {MatSliderModule} from '@angular/material/slider';
import 'hammerjs';
import { RecommendationCardComponent } from './pages/business/recommendation-card/recommendation-card.component';
import { InfoDialogComponent } from './pages/business/info-dialog/info-dialog.component';

import { HttpClientModule } from '@angular/common/http';

import { InternationalPhoneModule } from 'ng4-intl-phone';

import { HelpComponent } from './pages/help/help.component';
import { SuccessPageComponent } from './pages/success-page/success-page.component'
import { NgxSoapModule } from 'ngx-soap';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { LoaderService } from './common/loader/loader.service';
import { LoaderComponent } from './common/loader/loader.component';
import { CommonService } from './common.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { VersionComponent } from './pages/version/version.component';


@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    LoginComponent,
    NavigatorComponent,
    FooterComponent,
    BusinessComponent,
    RecommendationCardComponent,
    InfoDialogComponent,
    HelpComponent,
    SuccessPageComponent,
    LoaderComponent,
    VersionComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    MatSelectModule,
    MatSliderModule,
    MatCardModule,
    MatSlideToggleModule,
    MatDialogModule,
    HttpClientModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatRadioModule,
    InternationalPhoneModule,
    
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatStepperModule,
    // MatRadioModule,
    MatIconModule,
    NgxSoapModule,
    MatProgressSpinnerModule,
    NgSelectModule,
    //MaterialModule,
    // FormsModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production })
  ],
    providers: [
        LoaderService,
        CommonService
    ],
  entryComponents: [InfoDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
